import axios from 'axios'
import {
  GetShippingRules,
  ShippingResponse,
} from 'src/shared/types/pricing-types'

export const getShippingRules = (
  data: GetShippingRules,
  abortSignal?: AbortSignal,
) =>
  axios.post<ShippingResponse>('/api/payment/shipping-rules', data, {
    signal: abortSignal,
  })
